// extracted by mini-css-extract-plugin
module.exports = {"reservationListSectionList":"ReservationListSectionList-Jtails_reservationListSectionList_23mtD","reservationList":"ReservationListSectionList-Jtails_reservationList_2_KFS"};